import { createRoot } from 'react-dom/client';
import { Suspense } from 'react';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@lyse-as/formds-react';

import 'app/i18n/i18n';
import { store, persistor } from 'app/store/configure-store';
import { App } from 'app';
import { HeaderForSuspense } from 'app/features/header';

import './index.scss';
import '@lyse-as/formds-react/assets/fonts/Altibox Sans/altibox-sans-font.css';
import '@lyse-as/formds-react/assets/fonts/Altibox Display/altibox-display-font.css';
import '@lyse-as/formds-react/assets/stylesheets/formds-altibox.css';

const container = document.getElementById('root')!;
const root = createRoot(container);
const main = async () => {
  if (process.env.NODE_ENV === 'development') {
    if (['', '/', '/minesider'].includes(window.location.pathname)) {
      window.location.pathname = '/minesider/';
      return;
    }

    // Learn more about Mock Service Worker: https://mswjs.io/docs/
    if (process.env.REACT_APP_MOCK_API === 'true') {
      await import('app/mocks/browser').then(async ({ worker }) => {
        worker.start({
          serviceWorker: {
            url: '/minesider/mockServiceWorker.js',
          },
          onUnhandledRequest: 'bypass',
        });
      });
    }
  }

  root.render(
    <Provider store={store}>
      <BrowserRouter basename="/">
        <PersistGate loading={null} persistor={persistor}>
          <ThemeProvider scheme="neutral" layer="surface" theme="light">
            <Suspense fallback={<HeaderForSuspense />}>
              <App />
            </Suspense>
          </ThemeProvider>
        </PersistGate>
      </BrowserRouter>
    </Provider>,
  );
};

main();
